const api = process.env.REACT_APP_NODE_SERVER_URL;

export default api;
